import React from 'react';

export const variants = {
  atelier: {
    backdrop: {
      // Pure near-black — no warm or reddish hue
      base: 'linear-gradient(180deg, oklch(0.10 0.004 250) 0%, oklch(0.08 0.003 250) 50%, oklch(0.10 0.004 250) 100%)',
      coverBlurOpacity: 0,     // blurred cover tints the bg — off
      glowA: 'radial-gradient(circle, oklch(0.42 0.140 22 / 0) 0%, transparent 65%)',
      glowAOpacity: 0,         // burgundy glow — off
      glowB: 'radial-gradient(circle, oklch(0.84 0.010 250 / 0.12) 0%, transparent 70%)',
      glowBOpacity: 0.08,      // barely-there cool silver breath
      vignette: null,
      texture: null,           // hairlines removed
      textureOpacity: 0,
      grainOpacity: 0.18,
    },
    section: {
      // Book section — clean dark, no colour cast
      featuredBg:
        'linear-gradient(180deg, oklch(0.10 0.004 250) 0%, oklch(0.13 0.004 250) 14%, oklch(0.13 0.004 250) 86%, oklch(0.10 0.004 250) 100%)',
      featuredOverlay: null,
    },
    divider: {
      line: 'oklch(0.84 0.060 20 / 0.22)',
      ornament: (
        <>
          <span className="block w-8 sm:w-12 h-px bg-silver-500/40" />
          <span className="block font-noir italic text-silver-300 text-sm tracking-widest3">✦</span>
          <span className="block w-8 sm:w-12 h-px bg-silver-500/40" />
        </>
      ),
    },
    button: {
      primary:
        'bg-silver-50 hover:bg-burgundy-100 text-ink-deeper border border-silver-50 hover:border-burgundy-100 shadow-[0_12px_30px_-10px_oklch(0_0_0/0.6)]',
      primaryStyle: undefined,
      secondary:
        'border border-silver-500/30 text-silver-100 hover:text-silver-50 hover:border-silver-300 hover:bg-silver-500/[0.05]',
    },
    cover: {
      outerGlow: 'radial-gradient(closest-side, oklch(0.20 0.004 250 / 0.30) 0%, transparent 75%)',
      outerGlowOpacity: 0.5,
      innerGlow: 'radial-gradient(closest-side, oklch(0.20 0.004 250 / 0.10) 0%, transparent 65%)',
      innerGlowOpacity: 0.5,
      frameRing: null,
      imgShadow: 'drop-shadow(0 40px 60px oklch(0 0 0 / 0.60))',
    },
  },
};
